import * as Actions from "../actions/_ActionTypes";
import * as Pre from "../actions/_PreActionNames";

const initState = {
  isLoading: true,
  list: [],
  isGetData: true,
  facilityList: [],
  carWashList: [],
  coffeeShopAndRestaurantList: [],
  confirm: false,
  ParkingList: [],
  transactions: [],
};

const ApiReducer = (state = initState, action) => {
  const _state = { ...state };
  if (action.socket && action.socket.send) {
    if (action.type.indexOf("API") == 0) {
      _state.isLoading = true;
    }
    return _state;
  }
  var parsedData = null;
  if (action.payload && action.payload.data) {
    parsedData = JSON.parse(action.payload.data);
  }
  switch (action.type) {
    case Pre.API + Actions.MY_ORDERS:
      if (parsedData && Array.isArray(parsedData)) {
        _state.list = parsedData;
        const event = new Date();
      } else {
        _state.isGetData = false;
      }
      break;
    case Pre.API + Actions.MY_FACILITY_LIST:
      if (parsedData && Array.isArray(parsedData)) {
        _state.facilityList = parsedData;
      }
    case Pre.API + Actions.MY_CARWASH_ORDERS:
      if (parsedData && Array.isArray(parsedData)) {
        _state.carWashList = parsedData;
      } else {
        _state.isGetData = false;
      }
      break;
    case Pre.API + Actions.MY_COFFEESHOP_AND_RESTAURANT_ORDERS:
      if (parsedData && Array.isArray(parsedData)) {
        _state.coffeeShopAndRestaurantList = parsedData;
      } else {
        _state.isGetData = false;
      }
      break;
    case Pre.API + Actions.MY_TRANSACTIONS:
      if (parsedData && Array.isArray(parsedData)) {
        _state.transactions = parsedData;
      } else {
        _state.isGetData = false;
      }
      break;
    case Pre.API + Actions.MY_PARKING_ORDERS:
      if (parsedData && Array.isArray(parsedData)) {
        _state.ParkingList = parsedData;
      } else {
        _state.isGetData = false;
      }
      break;
    case Pre.API + Actions.CONFIRM_CARWASH:
      if (parsedData) {
        for (var i in initState.carWashList) {
          if (initState.carWashList[i].numRequestID == parsedData.orderId) {
            initState.carWashList[i].payment.numPaymentStatus = 1;
            initState.confirm = true;
            break;
          }
        }
      }
      break;
    case Pre.API + Actions.CONFIRM_RESTAURANT:
      if (parsedData) {
        for (var i in initState.restaurantList) {
          if (initState.restaurantList[i].numOrderID == parsedData.orderId) {
            initState.restaurantList[i].payment.numPaymentStatus = 1;
            initState.confirm = true;
            break;
          }
        }
      }
      break;
    case Pre.API + Actions.CONFIRM_COFFEESHOP:
      if (parsedData) {
        for (var i in initState.coffeeShopList) {
          if (initState.coffeeShopList[i].numOrderID == parsedData.orderId) {
            initState.coffeeShopList[i].payment.numPaymentStatus = 1;
            initState.confirm = true;
            break;
          }
        }
      }
      break;
    case Pre.API + Actions.CONFIRM_ORDER:
      if (parsedData) {
        for (var i in initState.list) {
          if (initState.list[i].numRequestID == parsedData.orderId) {
            initState.list[i].payment.numPaymentStatus = 1;
            initState.confirm = true;
            break;
          }
        }
      }
      break;
  }
  _state.isLoading = false;
  return _state;
};

export default ApiReducer;
